

/**
 * Типы тегов, используемые в географии
 */
export const TagEntity = {
    category: 'project_geograffee_category',
    tag: 'project_geograffee',
    designLabUnit: 'designlab_unit',
    main: 'main_category',
    city: 'cities',
    research: 'research_deziiign_main_category',
    artGeo: 'art_geograffee_main_category',
    eventsGeo: 'events_geograffee_main_category',
    creative: 'creative_main_category',
    onlinesRequired: 'onlines_required_category',
    required: 'required_category',
    dafes: 'dafes_main_category',
    ageytomesh: 'ageytomesh_main_category',
    ageytomeshRequired: 'ageytomesh_required_category',
    ageytomesh_edu: 'ageytomesh_edu_category',
    mainTags: 'main_tags',
    edu: 'edu_category',
    artEdu: 'art_geograffee_edu_category',
    university: 'university_category',
    country: 'country',
    places: 'places',
    artist: 'artist',
    brand: 'brand',
    handicraft_category: 'handicraft_category',
    persons_and_characters_category: 'persons_and_characters_category',
    style: 'style',
    science: 'science_category',
    mediaRequired: 'mediiia_required_category',
    legends_and_myths_category: 'legends_and_myths_category',
    fairy_tales_category: 'fairy_tales_category',
    actors_and_actresses_category: 'actors_and_actresses_category',
    mediiia_main_category: 'mediiia_main_category',
    prodeziiign_main_category: 'prodeziiign_main_category',
    prodeziiign_required_category: 'prodeziiign_required_category',
    prodeziiign_edu_category: 'prodeziiign_edu_category',
    art_gallllery_main_category: 'art_gallllery_main_category',
    deziiign_main: 'deziiign_main_category',
    deziiign_required: 'deziiign_required_category',
    geo_required: 'art_geograffee_required_category',
    hsestart_required_category: 'hsestart_required_category'
};


/**
 * Типы тегов, используемые в географии
 */
export const TagEntity = {
    category: 'project_geograffee_category',
    tag: 'project_geograffee',
    designLabUnit: 'designlab_unit',
    main: 'main_category',
    city: 'cities',
    research: 'research_deziiign_main_category',
    artGeo: 'art_geograffee_main_category',
    eventsGeo: 'events_geograffee_main_category',
    creative: 'creative_main_category',
    onlinesRequired: 'onlines_required_category',
    required: 'required_category',
    dafes: 'dafes_main_category',
    ageytomesh: 'ageytomesh_main_category',
    ageytomeshRequired: 'ageytomesh_required_category',
    ageytomesh_edu: 'ageytomesh_edu_category',
    mainTags: 'main_tags',
    edu: 'edu_category',
    artEdu: 'art_geograffee_edu_category',
    university: 'university_category',
    country: 'country',
    places: 'places',
    artist: 'artist',
    brand: 'brand',
    handicraft_category: 'handicraft_category',
    persons_and_characters_category: 'persons_and_characters_category',
    style: 'style',
    science: 'science_category',
    mediaRequired: 'mediiia_required_category',
    legends_and_myths_category: 'legends_and_myths_category',
    fairy_tales_category: 'fairy_tales_category',
    actors_and_actresses_category: 'actors_and_actresses_category',
    mediiia_main_category: 'mediiia_main_category',
    prodeziiign_main_category: 'prodeziiign_main_category',
    prodeziiign_required_category: 'prodeziiign_required_category',
    prodeziiign_edu_category: 'prodeziiign_edu_category',
    art_gallllery_main_category: 'art_gallllery_main_category',
    deziiign_main: 'deziiign_main_category',
    deziiign_required: 'deziiign_required_category',
    geo_required: 'art_geograffee_required_category',
    hsestart_required_category: 'hsestart_required_category'
};
